import React, { useEffect, useState } from 'react';
import Datatable from '../../components/Datatable';
import FormDialog, { Text } from '../../components/Datatable/FormDialog';
import { Box, Button, IconButton, Snackbar, TextField, Tooltip, Typography, setRef } from '@mui/material';
import { create, get_one, update, delete_one } from '../../services/api';
import EditIcon from '@mui/icons-material/Edit';
import { useNotify } from '../../components/Datatable/NotifyProvider';
import { useFormError } from '../../components/Datatable/FormErrorProvider';
import { RemoveCircleOutline } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../components/AuthProvider';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { red, green } from '@mui/material/colors';
import KeyIcon from '@mui/icons-material/Key';
import CircularProgress from '@mui/material/CircularProgress';
import api from '../../services/api';
import Backdrop from '@mui/material/Backdrop';
import SyncIcon from '@mui/icons-material/Sync';
import { useLoading } from '../../components/LoadingProvider';

export default function Node() {
    const notify = useNotify()
    const auth = useAuth()
    const loading = useLoading()
    const { isLoading, setLoading } = loading
    const [formState, setFormState] = useState({
        open: false,
        id: null,
    })
    const [refresh, setRefresh] = useState(false)
    React.useEffect(() => {
        document.title = "IPV7 Tools - DNS Zona Local"
    }, [])
    return (
        <>
            <FormItem
                open={formState.open}
                id={formState.id}
                handlerClose={() => setFormState({ open: false, id: null })}
                handlerSubmit={() => setRefresh(true)}
                btnSubmit={formState.id ? 'Atualizar' : 'Salvar'}
                btnClose={'Fechar'}
            ></FormItem>
            <Datatable
                refresh={refresh}
                handlerRefresh={() => setRefresh(!refresh)}
                title='Zona Local'
                endpoint='/dns/localzone'
                options={{
                    customToolbar: () =>
                        <>
                            <Tooltip title="Remover todos os filtros">
                                <IconButton onClick={() => { localStorage.removeItem("datatable" + "'/dns/local_zone"); location.reload() }} >
                                    <RemoveCircleOutline />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Adicionar">
                                <IconButton disabled={!auth.hasPerm("dns_localzone.create")}
                                    onClick={() => setFormState({ open: true, id: null })}
                                >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ,
                    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => ""
                }
                }
                columns={[
                    {
                        name: 'id',
                        label: 'ID',
                        options: {
                            display: false
                        }
                    },
                    {
                        name: 'domain',
                        label: 'Domínio',
                    },
                    {
                        name: 'ip',
                        label: 'IP',
                    },
                    {
                        name: 'actions',
                        label: 'Ações',
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRender: (value, tableMeta, updateValue) => {
                                const id = tableMeta.rowData[0]
                                return (
                                    <>
                                        <IconButton
                            disabled={!auth.hasPerm("dns_localzone.delete")}
                            onClick={() => {
                                if (confirm('Deseja excluir a zona local?')) {
                                    setLoading(true)
                                    api.delete(`dns/localzone/${id}`).then(res=>{
                                        if (res.data.nodes){
                                            const type_error = res.data.nodes.every(node => node.result == false) ? 'error' : res.data.nodes.every(node => node.result == true) ? 'success' : 'warning'
                                            if (res.data.nodes?.length == 0){
                                                notify.setNotify({ open: true, message: 'As informações foram salvas no sistema, porém nenhum DNS foi atualizado', severity: "warning" })
                                                return
                                            }
                                            const msg = res.data.nodes.map(node => `${node.name}: ${node.result ==1 ? "Executado com sucesso." : "Falhou."}` ).join('\n')
                                            notify.setNotify({ open: true, message: msg, severity: type_error })
                                            return
                                        }
                                        if (res.data.error){
                                            notify.setNotify({ open: true, message: res.error, severity: 'error' })
                                            return
                                        } 
                                        notify.setNotify({ open: true, message: 'Zona Local deletada com sucesso.', severity: 'success' })
                                    }).catch(e=>{
                                        notify.setNotify({ open: true, message: e.message, severity: 'error' })
                                    
                                    }).finally(()=>{
                                        setRefresh(true)
                                        setLoading(false)
                                    })
                                    
                                }
                            }}>
                            <DeleteIcon />
                        </IconButton>
                                    </>
                                )
                            }
                        }
                    }
                ]}

            />
        </>
    )
}




function FormItem({ id, open, handlerClose, handlerSubmit, btnClose = 'Fechar', btnSubmit = 'Salvar' }) {
    const notify = useNotify()
    const error = useFormError()
    const auth = useAuth()
    const loading = useLoading()
    const { isLoading, setLoading } = loading

    useEffect(() => {
        if (open){

            setState({
                ip: '',
                domain: '', 
            })
            error.setErrors([])
        }
    },[open])


    const [state, setState] = useState({
        ip: '',
        domain: '',

    })
    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    }

    const wrapperSubmit = () => {
        setLoading(true)
        create('/dns/localzone/create', state)
                .then(res => {
                    if (res.data.nodes){
                        const type_error = res.data.nodes.every(node => node.result == false) ? 'error' : res.data.nodes.every(node => node.result == true) ? 'success' : 'warning'
                        if (res.data.nodes?.length == 0){
                            notify.setNotify({ open: true, message: 'As informações foram salvas no sistema, porém nenhum DNS foi atualizado', severity: "warning" })
                            error.setErrors([])
                            return
                        }
                        const msg = res.data.nodes.map(node => `${node.name}: ${node.result ==1 ? "Executado com sucesso." : "Falhou."}` ).join('\n')
                        notify.setNotify({ open: true, message: msg, severity: type_error })
                    }
                    else if (res.data.errors) {
                        error.setErrors(res.data.errors)
                        return
                    }else {
                        notify.setNotify({ open: true, message: 'Zona Local criada com sucesso.', severity: 'success' })
                        error.setErrors([])
                    }
                })
                .catch(e =>
                    notify.setNotify({ open: true, message: e.message, severity: 'error' }))
                    .finally(()=>{
                        handlerSubmit()
                        setLoading(false)
                        handlerClose()
                })
        

    }
    return (
        <Box component={"form"}
            onSubmit={wrapperSubmit}
            sx={{ m: 2 }}
            display={'flex'}
            flexWrap={'wrap'}
        >

            <FormDialog
                title={
                    <Box display={"flex"} justifyContent={'space-between'}>
                        <Typography variant="h6" component="div">{id ? 'Editar' : 'Adicionar'} Zona Local</Typography>
                        
                    </Box>
                }
                open={open}
                handlerSubmit={wrapperSubmit}
                handlerClose={handlerClose}
                btnSubmit={btnSubmit}
                btnClose={btnClose}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                    <TextField
                        sx={{ mb: 2, mt: 1}}
                        error={error.verify("domain")}
                        helperText={error.msgError("domain")}
                        label='Domínio'
                        name={"domain"}
                        value={state.domain}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2}}
                        error={error.verify('ip')}
                        helperText={error.msgError('ip')}
                        label='IP'
                        value={state.ip}
                        name={'ip'}
                        onChange={handleChange}
                    />
                   


                </Box>

            </FormDialog>
        </Box>
    )
}


